import axios from 'axios';
import _ from 'lodash';
import { routes } from '../../constants/index.js';

const { 
    SERVICE: { CAMPAIGNS_APP },
    ENDPOINTS: { 
        CAMPAIGNS: { 
            GENERATE_ARTWORK,
            EXTRACT_COLOR_PALETTE,
            GET_IMAGE_BUFFER,
            GET_ARTWORK_STATUS
        } 
    } 
} = routes;

const getArtworkPredictionId = async ({personality, texture, artist, style, colorPalette, locale}) => {
    const url = `${CAMPAIGNS_APP}${GENERATE_ARTWORK}`;

    try {
        const request = await axios({
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'x-tme-lc': locale
            },
            data: {
                payload:{
                    personality, 
                    texture, 
                    artist,
                    style,
                    colorPalette
                }
            }
        });
        
        return _.get(request, `data`, {});

    } catch (err) {
        console.log(err)
    } 
}

const getArtworkStatus = async ({predictionId, personality, texture, artist, style, atmosphere, vehicleColour, locale}) => {
    const url = `${CAMPAIGNS_APP}${GET_ARTWORK_STATUS}`;

    try {
        const request = await axios({
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'x-tme-lc': locale
            },
            data: {
                payload:{
                    predictionId,
                    personality, 
                    texture, 
                    artist,
                    style,
                    atmosphere, 
                    vehicleColour
                }
            }
        });
        
        return _.get(request, `data`, {});

    } catch (err) {
        console.log(err)
    } 
}

const extractColorPalette = async (options) => {
    const url = `${CAMPAIGNS_APP}${EXTRACT_COLOR_PALETTE}`;
    
    try {
        const request = await axios({
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            data: {
                payload:options
            }
        });
        
        return _.get(request, `data`, {});

    } catch (err) {
        console.log(err)
    } 
}

const getImageBuffer = async (imageUrl) => {
    const url = `${CAMPAIGNS_APP}${GET_IMAGE_BUFFER}`;
    
    try {
        const request = await axios({
            method: 'POST',
            url,
            headers: {
                'Accept': 'application/octet-stream'
            },
            data: {
                payload:{
                    artwork:imageUrl
                }
            },
            responseType: 'arraybuffer'
        });
        
        return _.get(request, `data`, {});

    } catch (err) {
        throw err
    } 
}

export {
    getArtworkPredictionId,
    getArtworkStatus,
    extractColorPalette,
    getImageBuffer
}